module.exports = "//static.hsappstatic.net/LoginUI/static-1.15179/img/SUI_desktop.svg"